import ArchiveSearchBar from './ArchiveSearchBar';
import ArchiveAuditionCard from './ArchiveAuditionCard';

export default function ArchiveListView({ auditions, boards = [], onRemove, onMove, onOpen }) {
  return (
    <div style={{ paddingTop: '30px' }}>
      <ArchiveSearchBar />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>
        {auditions.map(item => (
          <ArchiveAuditionCard
            key={item.id}
            item={item}
            boards={boards}
            onRemove={onRemove}
            onMove={onMove}
            onOpen={onOpen}
          />
        ))}
      </div>
    </div>
  );
}
